// src/themes/lino/elements/Header/HeaderSpacer.tsx
'use client';

import { useIsHome } from '@/core/hooks/use-is-home';

// هدر fixed هست، پس اگه جاش تو flow صفحه رزرو نشه، محتوای هر صفحه زیرش قایم می‌شه.
// تو صفحه‌ی خانه لازم نیست (هدر عمداً شفافه و رو هیروی صفحه سوار می‌شه)،
// ولی تو همه‌ی صفحه‌های دیگه باید دقیقاً به اندازه‌ی ارتفاع هدر (mt-4 + h-20 = 96px) فاصله بده.
export default function HeaderSpacer() {
    const isHome = useIsHome();

    if (isHome) return null;

    return <div aria-hidden className="h-24" />;
}